import { createSelector } from "reselect";
import { SharedState } from "../types/SharedState";

// TODO(cochamberlain): Merge this file into session.ts and remove this function.
const getSessionState = (state: SharedState) => state.session;

/** Get the current session theme name. */
export const getThemeName = createSelector(
  [getSessionState],
  session => session.themeName
);
